import { SET_FONTDETAILLIST } from '../actions';

const fontdetails = (state = [], action) => {
  switch (action.type) {
	case SET_FONTDETAILLIST:
      return [...action.value];  
    default: return state;
  }
}

export default fontdetails;
